import { render, staticRenderFns } from "./platinum_mobile.vue?vue&type=template&id=6bfc896c&scoped=true&"
import script from "./platinum_mobile.vue?vue&type=script&lang=js&"
export * from "./platinum_mobile.vue?vue&type=script&lang=js&"
import style0 from "./platinum_mobile.vue?vue&type=style&index=0&id=6bfc896c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfc896c",
  null
  
)

export default component.exports